<template>
  <Details
    title="membership"
    resource="memberships"
    data-provider="$raaDataProvider"
    :base-path="basePath"
    route-id-param="membershipId"
  >
    <template v-slot:side-panel>
      <DetailsSidePanel entity-title="membership" new-entity></DetailsSidePanel>
    </template>
    <template v-slot:default="detailsProps">
      <MembershipForm
        :initial-values="initialValues"
        :on-submit="detailsProps.handleSubmit"
        :loading="detailsProps.loading"
        @close="detailsProps.redirectToList"
      />
    </template>
  </Details>
</template>

<script>
  import ModalNavigation from '@/mixins/ModalNavigation';
  import MembershipForm from "@/views/auth/raa-devtools/memberships/MembershipForm";
  import Details from "@/components/auth/details/Details";
  import DetailsSidePanel from "@/components/auth/details/DetailsSidePanel";
  import {v4} from "uuid";

  export default {
    name: "MembershipCreate",
    components: {
      MembershipForm,
      Details,
      DetailsSidePanel,
    },
    mixins: [ModalNavigation],
    computed: {
      basePath: function () {
        return this.$route.name.replace('create', 'index');
      },
      initialValues() {
        return {
          id: v4()
        }
      }
    }
  }
</script>

